const categories = {
  movie: {
    title: 'watch-moovie',
  },
  fitness: {
    title: 'fitness',
  },
  cleaning: {
    title: 'home-stuff',
  },
  cooking: {
    title: 'cooking',
  },
  selfDevelopment: {
    title: 'self-development',
  },
  selfCare: {
    title: 'self-care',
  },
  hobby: {
    title: 'hobby',
  },
  socializing: {
    title: 'socializing',
  },
}

export const mediaTypes = {
  video: {
    name: 'video',
  },
  image: {
    name: 'image',
  },
  link: {
    name: 'link',
  },
}

const imagePathPrefix = '/quarantine-what-to-do/images';

export const activities = {
  list: [
    {
      category: categories.movie,
      title: 'Watch "Once Upon a Time in Hollywood" (2019) movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/1.jpg`,
          origin: 'https://unsplash.com/photos/CiUR8zISX60',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "The Grand Budapest Hotel" (2014) movie ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/2.jpg`,
          origin: 'https://unsplash.com/photos/AEeoY_aqvNk',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "King Arthur: Legend of the Sword" (2017) ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/3.jpg`,
          origin: 'https://unsplash.com/photos/PpYOQgsZDM4',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "Jumanji" (1995) movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/4.jpg`,
          origin: 'https://unsplash.com/photos/yjXAtMCPdGs',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "Ferdinand" (2017) movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/5.jpg`,
          origin: 'https://unsplash.com/photos/h5cFbbecEuY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "Now You See Me" (2013) movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/6.jpg`,
          origin: 'https://unsplash.com/photos/i4W8OINLI_I',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "The Hitman\'s Bodyguard" (2017) movie ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/7.jpg`,
          origin: 'https://unsplash.com/photos/c2FAMnQaCDE',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "Guardians of the Galaxy" (2014) movie ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/8.jpg`,
          origin: 'https://unsplash.com/photos/WkG2r7FVQLw',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch "Despicable Me" (2010) movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/9.jpg`,
          origin: 'https://unsplash.com/photos/N9BhOxR3c0A',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1970',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1972',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1974',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1976',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1978',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1980',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1982',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1984',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1986',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1988',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/10-19.jpg`,
          origin: 'https://unsplash.com/photos/iNp-qD5ibXY',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1990',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1991',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1992',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1993',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1994',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1995',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1996',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1997',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1998',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 1999',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/20-29.jpg`,
          origin: 'https://unsplash.com/photos/2uwFEAGUm6E',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2000',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2001',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2002',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2003',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2004',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2005',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2006',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2007',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2008',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2009',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch the most popular movie of 2010',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/30-40.jpg`,
          origin: 'https://unsplash.com/photos/gdsp6wNn7cM',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch a science fiction movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch a comedy movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch a documentary movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch a sport & fitness movie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Watch a movie in a foreign language',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Find a list of the top 100 movies. Watch any movie from 10 to 20 list',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Find a list of the top 100 movies. Watch any movie from 5 to 15 list',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Find a list of the top 100 movies. Watch any movie from 7 to 33 list',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.movie,
      title: 'Find a list of the top 100 movies. Watch any movie from 70 to 90 list',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/movies/41-49.jpg`,
          origin: 'https://unsplash.com/photos/G-zsrSWvKmc',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/XCIviBT3Txc',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/r7xsYgTeM2Q',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/UEEsdXn8oG8',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/Nw2oBIrQGLo',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/4vTJHUDB5ak',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/fNN84pjAwYM',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/3Elmwad8XDI',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes of yoga',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/i9VkLOj-A-s',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes stretching time',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/flDQ-Av5DZ8',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes stretching time',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/L_xrDAtykMI',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes stretching time',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/8GL73mrsvJ8',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes stretching time',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/h0Sqc90rUY4',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 minutes stretching time',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/7KSoWzbznhk',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/QNtCo20dD6w',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/bleOTMDa3_4',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/aCa8R9II8F0',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/njKwu3dqD0Y',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/VHyGqsPOUHs',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/ByQ3z7PuS-c',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/Jy5Ra7jIGak',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/Spc5yl47h1Y',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/0DSrudz6IVY',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/IeGrTqW5lek',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/Q-DwUmV2Igs',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/xvn3HlSxYdM',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '15 min home workout',
      media: [
        {
          type: mediaTypes.video,
          link: 'https://www.youtube.com/embed/0LlT7MSKJBc',
        },
      ],
    },
    {
      category: categories.fitness,
      title: 'Squats Challenge. Every hour from 11:00 a.m. to 6:00 p.m., squat 15 times. Set a timer for every hour',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/fitness/1.jpg`,
          origin: 'https://unsplash.com/photos/wy_L8W0zcpI',
        },
      ],
    },
    {
      category: categories.fitness,
      title: 'Plank Challenge. Every hour from 11:00 a.m. to 6:00 p.m., static plank for 2 minutes. Set a timer for every hour',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/fitness/2.jpg`,
          origin: 'https://unsplash.com/photos/QP84K2HuIMY',
        },
      ],
    },
    {
      category: categories.fitness,
      title: '4 Minutes TABATA',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/fitness/3.jpg`,
          origin: 'https://unsplash.com/photos/hdBaq9W0hRY',
        },
      ],
    },
    {
      category: categories.fitness,
      title: 'Learn a new dance on Youtube',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/fitness/4.jpg`,
          origin: 'https://unsplash.com/photos/6Woj_wozqmA',
        },
      ],
    },
    {
      category: categories.fitness,
      title: 'Go jogging for 30 minutes (only if you are not breaking quarantine rules)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/fitness/5.jpg`,
          origin: 'https://unsplash.com/photos/lhXycMCAlQk',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash windows at home',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/1.jpg`,
          origin: 'https://unsplash.com/photos/U8zsjmKA840',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean out your wardrobe',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/2.jpg`,
          origin: 'https://unsplash.com/photos/OYYE4g-I5ZQ',
        },
      ],
      
    },
    {
      category: categories.cleaning,
      title: 'Transplant flowers into new pot / outdoors',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/3.jpg`,
          origin: 'https://unsplash.com/photos/gKk9rpyDryU',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Plant the strawberries',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/4.jpg`,
          origin: 'https://unsplash.com/photos/IdrzXJQlw5w',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Plant the lavender',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/5.jpg`,
          origin: 'https://unsplash.com/photos/9OflqNWhcrE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Plant a hydrangea',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/6.jpg`,
          origin: 'https://unsplash.com/photos/qVjIBN1P-co',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Buy a Monstera deliciosa',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/7.jpg`,
          origin: 'https://unsplash.com/photos/xRyL63AwZFE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Buy a Monstera monkey leaf',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/8.jpg`,
          origin: 'https://unsplash.com/photos/082Z-3uTRAQ',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Buy a bouquet of Tulips',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/9.jpg`,
          origin: 'https://unsplash.com/photos/OyXkIJSB09M',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Order a new flower. Name it "Quarantine"',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/10.jpg`,
          origin: 'https://unsplash.com/photos/An0uaO4IhcQ',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Fix what\'s broken, but you were too lazy to fix it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/11.jpg`,
          origin: 'https://unsplash.com/photos/CrhsIRY3JWY',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean up first aid kit (throw away old medicines)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/12.jpg`,
          origin: 'https://unsplash.com/photos/m1Hq4ibP9rc',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean up cosmetic bag (throw away old cosmetics)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/13.jpg`,
          origin: 'https://unsplash.com/photos/BkaD07QEiJc',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Redecorate your room',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/14.jpg`,
          origin: 'https://unsplash.com/photos/JIUjvqe2ZHg',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Decorate balcony',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/15.jpg`,
          origin: 'https://unsplash.com/photos/6-nCXHU1hKk',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean curtains',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/16.jpg`,
          origin: 'https://unsplash.com/photos/Fd9tUmRBJzk',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Listen an audiobook for 20 minutes while you wash the dishes',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/17.jpg`,
          origin: 'https://unsplash.com/photos/hQOHDAibf6A',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean your shoes',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/18.jpg`,
          origin: 'https://unsplash.com/photos/Np_nvRuhpUo',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash your outerwear',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/19.jpg`,
          origin: 'https://unsplash.com/photos/w_W9lz-emJw',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash the oven',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/20.jpg`,
          origin: 'https://unsplash.com/photos/ktVKZRYUP4Y',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash the microwave',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/21.jpg`,
          origin: 'https://unsplash.com/photos/FaTf3ppLIBE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash the fridge',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/22.jpg`,
          origin: 'https://unsplash.com/photos/Eb6hMEhGlKY',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Analyze which foods you throw away the most. It may be worth less to buy them',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/23.jpg`,
          origin: 'https://unsplash.com/photos/BMnX7L9G5xc',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Analyze which foods you are running out of the fastest. Order more next time',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/24.jpg`,
          origin: 'https://unsplash.com/photos/D6Tu_L3chLE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean the carpet with washing powder',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/25.jpg`,
          origin: 'https://unsplash.com/photos/Vra_DPrrBlE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Dust the baseboards',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/26.jpg`,
          origin: 'https://unsplash.com/photos/5i0GnoTTjSE',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash the car',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/27.jpg`,
          origin: 'https://unsplash.com/photos/d12EpJSZmes',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Wash your bike',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/28.jpg`,
          origin: 'https://unsplash.com/photos/8AGJBTFpFso',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean up your pantry',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/29.jpg`,
          origin: 'https://unsplash.com/photos/_VHQ24Mjleo',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Buy new candles',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/30.jpg`,
          origin: 'https://unsplash.com/photos/tykgm1UJXA4',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Buy new pillowcases for the sofa in the living room',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/31.jpg`,
          origin: 'https://unsplash.com/photos/k8AlRsl7L8E',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean out your purse',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/32.jpg`,
          origin: 'https://unsplash.com/photos/aXJdmnxauwY',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean up the bookshelves',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/33.jpg`,
          origin: 'https://unsplash.com/photos/z_DkoUqgx6M',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Cancel the subscription you\'ve long wanted to cancel',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/34.jpg`,
          origin: 'https://unsplash.com/photos/XajinLtRMA0',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean your mail',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/35.jpg`,
          origin: 'https://unsplash.com/photos/fb7yNPbT0l8',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean your old posts in Instagram',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/36.jpg`,
          origin: 'https://unsplash.com/photos/CiSizRTO8U8',
        },
      ],
    },
    {
      category: categories.cleaning,
      title: 'Clean your old posts on Facebook',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cleaning/37.jpg`,
          origin: 'https://unsplash.com/photos/bo8CqGmjjrI',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Cook an apple pie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/1.jpg`,
          origin: 'https://unsplash.com/photos/J5QovDGYK8s',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Bake chocolate cookies ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/2.jpg`,
          origin: 'https://unsplash.com/photos/OfdDiqx8Cz8',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Prepare Vanilla Iced Latte',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/3.jpg`,
          origin: 'https://unsplash.com/photos/E6RTpqvOasU',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the French recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/4.jpg`,
          origin: 'https://unsplash.com/photos/N_enD_8s3nI',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Italian recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/5.jpg`,
          origin: 'https://unsplash.com/photos/12eHC6FxPyg',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Swedish recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/6.jpg`,
          origin: 'https://unsplash.com/photos/Fuj145tMO84',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Swiss recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/7.jpg`,
          origin: 'https://unsplash.com/photos/ba7617qjMmo',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Indian recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/8.jpg`,
          origin: 'https://unsplash.com/photos/EdzsUFqHbaY',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Chinese recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/9.jpg`,
          origin: 'https://unsplash.com/photos/LO7rNP0LRro',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Ukrainian recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/10.jpg`,
          origin: 'https://www.instagram.com/p/B9otL6NpMoF/',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Brazilian recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/11.jpg`,
          origin: 'https://unsplash.com/photos/Fa83qv6hCgA',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Korean recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/12.jpg`,
          origin: 'https://unsplash.com/photos/UI0ylIEHxMM',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Argentinean recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/13.jpg`,
          origin: 'https://unsplash.com/photos/eRyMytuT0yg',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the Uzbek recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/14.jpg`,
          origin: 'https://www.instagram.com/p/BtnWLjAgJlA/',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Find the vegan recipe and cook it',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/15.jpg`,
          origin: 'https://unsplash.com/photos/1SPu0KT-Ejg',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Prepare smoothie',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/16.jpg`,
          origin: 'https://www.instagram.com/p/B-PICz6pBKo/',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Order Happy Meal with a toy for you',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/17.jpg`,
          origin: 'https://unsplash.com/photos/BJ6Bkrl1e-U',
        }
      ],
    },
    {
      category: categories.cooking,
      title: 'Drink a cup of coffee',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/18.jpg`,
          origin: 'https://www.instagram.com/p/B8lxI5Yp7dA/',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Order your favorite cake',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/19.jpg`,
          origin: 'https://unsplash.com/photos/lsqPDLZMy2I',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Write the menu a week in advance',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/20.jpg`,
          origin: 'https://unsplash.com/photos/P4jRJYN33wE',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Cook hot chocolate',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/21.jpg`,
          origin: 'https://unsplash.com/photos/MjZq7A2RJxQ',
        },
      ],
    },
    {
      category: categories.cooking,
      title: 'Prepare some lemonade',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/cooking/22.jpg`,
          origin: 'https://unsplash.com/photos/IsZWx2oIRb0',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: '30 minutes of reading a book',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/1.jpg`,
          origin: 'https://unsplash.com/photos/-m0xspcr6Xw',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read the poetry of the classics',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/2.jpg`,
          origin: 'https://unsplash.com/photos/7bYARiDY7lQ',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Take the online test "Your Language of Love" from Gary Chapman\'s book "5 Languages of Love."',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/3.jpg`,
          origin: 'https://unsplash.com/photos/qdPnQuGeuwU',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Calculate by previous expenses where you spend the most money',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/4.jpg`,
          origin: 'https://unsplash.com/photos/5fNmWej4tAA',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Calculate how many calories you eat per day. Examine how many calories you need each day',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/5.jpg`,
          origin: 'https://unsplash.com/photos/nTZOILVZuOg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read / watch the video how to grow more subscribers on Instagram',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/6.jpg`,
          origin: 'https://unsplash.com/photos/aM9sj98dI2A',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a German fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/7.jpg`,
          origin: 'https://unsplash.com/photos/k2Kcwkandwg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Ukrainian fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Chinese fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Thai fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a American fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Indian fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Norwegian fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Argentinean fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Spanish fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Dutch fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read a Italian fairy tale for yourself before sleeping',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/8-17.jpg`,
          origin: 'https://unsplash.com/photos/ZD03qVhBJZg',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: '20 minutes of foreign language in Duolingo app',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/18.jpg`,
          origin: 'https://unsplash.com/photos/ncLdDcvrcfw',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Write a list of 5 of your dreams. Meditate on them',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/19.jpg`,
          origin: 'https://unsplash.com/photos/Ak5c5VTch5E',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read biography of distinguished men/women',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/20.jpg`,
          origin: 'https://unsplash.com/photos/FTNGfpYCpGM',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Write 10 things for which you are grateful',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/21.jpg`,
          origin: 'https://unsplash.com/photos/HWbxSLvmSww',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Learn a new song',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/22.jpg`,
          origin: 'https://unsplash.com/photos/6k4HkET8dPM',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Learn a new anecdote',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/23.jpg`,
          origin: 'https://unsplash.com/photos/wOHH-NUTvVc',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Solve a Sudoku',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/24.jpg`,
          origin: 'https://unsplash.com/photos/4eBOPIJliNc',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Write a story on at least 3 sheets of A4 format',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/25.jpg`,
          origin: 'https://unsplash.com/photos/AgQaMOQFWeA',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read the Book of Proverbs from the Bible',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/26.jpg`,
          origin: 'https://unsplash.com/photos/1EbsMYrAu-s',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Write a letter to yourself "10 years ago"',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/27.jpg`,
          origin: 'https://unsplash.com/photos/OQMZwNd3ThU',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Write a letter to yourself "10 years ahead"',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/28.jpg`,
          origin: 'https://unsplash.com/photos/DR31squbFoA',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Watch the video / read about face care',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/29.jpg`,
          origin: 'https://unsplash.com/photos/rlNibgIqi4o',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read your old notes or diary',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/30.jpg`,
          origin: 'https://unsplash.com/photos/tcyW6Im5Uug',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Read your first posts on Facebook',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/31.jpg`,
          origin: 'https://unsplash.com/photos/I6wCDYW6ij8',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Find out what is the historical date (possibly a holiday) in your country today',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/32.jpg`,
          origin: 'https://unsplash.com/photos/nvFpb_MMRj8',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Count your expenses. What can you save on?',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/33.jpg`,
          origin: 'https://unsplash.com/photos/lCPhGxs7pww',
        },
      ],
    },
    {
      category: categories.selfDevelopment,
      title: 'Think about your diet. Are you satisfied with your weight? Read the articles on healthy eating',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfDevelopment/34.jpg`,
          origin: 'https://unsplash.com/photos/ECXB0YAZ_zU',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Take a bath with music',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/1.jpg`,
          origin: 'https://unsplash.com/photos/TOZqUHD8L38',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Spend the day without a phone',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/2.jpg`,
          origin: 'https://unsplash.com/photos/t8T_yUgCKSM',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Spend the day without Instagram',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/3-6.jpg`,
          origin: 'https://unsplash.com/photos/yFY5DEhD_kY',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Spend the day without Reddit',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/3-6.jpg`,
          origin: 'https://unsplash.com/photos/yFY5DEhD_kY',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Spend the day without Facebook',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/3-6.jpg`,
          origin: 'https://unsplash.com/photos/yFY5DEhD_kY',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Spend the day without Tik Tok',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/3-6.jpg`,
          origin: 'https://unsplash.com/photos/yFY5DEhD_kY',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: '15 minutes sit in silence with closed eyes',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/7.jpg`,
          origin: 'https://unsplash.com/photos/vzN7pP6twA4',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Drink coffee at dawn on the balcony',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/8.jpg`,
          origin: 'https://unsplash.com/photos/_wkd7XBRfU4',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Drink tea on the balcony at sunset',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/9.jpg`,
          origin: 'https://unsplash.com/photos/BeDY9KuP0sI',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Listen to the birds singing on the balcony in the morning/ evening',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/10.jpg`,
          origin: 'https://unsplash.com/photos/cZpEECyOids',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Do a manicure',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/11.jpg`,
          origin: 'https://unsplash.com/photos/Xf7o2W7qgP0',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Do a pedicure',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/12.jpg`,
          origin: 'https://unsplash.com/photos/qeuJczNo54w',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Order / buy a bouquet of flowers home',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/13.jpg`,
          origin: 'https://unsplash.com/photos/7pGehyH7o64',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Listen Ludovico Einaudi music in headphones on the balcony',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/14.jpg`,
          origin: 'https://unsplash.com/photos/d3VCYpRp6Uw',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Look at the YouTube make-up lesson and try to make yourself',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/15.jpg`,
          origin: 'https://unsplash.com/photos/k8OCHhEymME',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Let your husband do your hairstyle',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/16.jpg`,
          origin: 'https://unsplash.com/photos/oM5YoMhTf8E',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Let your husband make you makeup',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/17.jpg`,
          origin: 'https://unsplash.com/photos/FoeIOgztCXo',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Meet the sunrise',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/18.jpg`,
          origin: 'https://unsplash.com/photos/3G1TcykU6jA',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Meet the sunset',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/19.jpg`,
          origin: 'https://unsplash.com/photos/Dud7rPgq6ik',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Shave/grow a mustache',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/20.jpg`,
          origin: 'https://unsplash.com/photos/FvKpUZCbZ-s',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Order a new perfume',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/21.jpg`,
          origin: 'https://unsplash.com/photos/LkT5-JCePUY',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Order a new face cream',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/22.jpg`,
          origin: 'https://unsplash.com/photos/y_CSTKJ0bEs',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Take a walk on Google Maps down the street where you lived as a child',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/23.jpg`,
          origin: 'https://unsplash.com/photos/5jhLtxcS-Lg',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Order a new pajama',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/24.jpg`,
          origin: 'https://unsplash.com/photos/1xzSAlZUVSc',
        },
      ],
    },
    {
      category: categories.selfCare,
      title: 'Find your photos 10 years ago. Choose 3 of your favorites',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/selfCare/25.jpg`,
          origin: 'https://unsplash.com/photos/eWIYSPi6R8g',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a picture with pencils',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/1.jpg`,
          origin: 'https://unsplash.com/photos/JQ3JSM--qIg',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a picture with paints',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/2.jpg`,
          origin: 'https://unsplash.com/photos/FwF_fKj5tBo',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a picture with watercolor paints',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/3.jpg`,
          origin: 'https://unsplash.com/photos/Yova_ho8NhU',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a sketch',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/4.jpg`,
          origin: 'https://unsplash.com/photos/Hl3LUdyKRic',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Collect puzzles',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/5.jpg`,
          origin: 'https://unsplash.com/photos/sOK9NjLArCw',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Buy 3D puzzles',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/6.jpg`,
          origin: 'https://unsplash.com/photos/GBHhIyWftHs',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Buy coloring for adults ',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/7.jpg`,
          origin: 'https://unsplash.com/photos/lI1z94nf0RM',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Play at musical instruments',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/8.jpg`,
          origin: 'https://unsplash.com/photos/dWcUncxocQY',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Learn a new trick with your dog',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/9.jpg`,
          origin: 'https://unsplash.com/photos/qO-PIF84Vxg',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Change at phone wallpaper',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/10.jpg`,
          origin: 'https://unsplash.com/photos/0tRhUZKg_88',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Search for phone or desktop wallpaper',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/11.jpg`,
          origin: 'https://unsplash.com/photos/t9DooibgMEk',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Free up space on your device',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/12.jpg`,
          origin: 'https://unsplash.com/photos/tpuAo8gVs58',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Collect Lego',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/13.jpg`,
          origin: 'https://unsplash.com/photos/hcLSA1MiU3A',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Make paper airplanes or other figures',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/14.jpg`,
          origin: 'https://unsplash.com/photos/UJrFn_K7OFQ',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Disco in headphones. Turn on the music and dance at full volume',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/15.jpg`,
          origin: 'https://unsplash.com/photos/DBGwy7s3QY0',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Look at old family photos',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/16.jpg`,
          origin: 'https://unsplash.com/photos/73OJLcahQHg',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Knit a scarf',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/17.jpg`,
          origin: 'https://unsplash.com/photos/WomyQGrd9ss',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Learn some trick',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/18.jpg`,
          origin: 'https://unsplash.com/photos/t6w2xpAI12g',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Learn the card trick',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/19.jpg`,
          origin: 'https://unsplash.com/photos/2ha8OG5bOmg',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a self-portrait',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/20.jpg`,
          origin: 'https://unsplash.com/photos/Ox3SuY9QbDU',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Draw a tattoo on your hand with a black pen',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/21.jpg`,
          origin: 'https://unsplash.com/photos/R9rIQVa1wWA',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Order a board game',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/22.jpg`,
          origin: 'https://unsplash.com/photos/laNNTAth9vs',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Shoot a video vlog of your day',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/23.jpg`,
          origin: 'https://unsplash.com/photos/7aM7i2lav8U',
        },
      ],
    },
    {
      category: categories.hobby,
      title: 'Build a fort (living room couch cushions, sheets, flashlights)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/hobby/24.jpg`,
          origin: 'https://unsplash.com/photos/XoOXuRDIBPg',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Play games online with friends',
      media: [
        {
          type: mediaTypes.link,
          link: 'http://codenames.me/',
          text: '▶️ Game Codenames game link',
          image: `${imagePathPrefix}/socializing/1.jpg`,
          origin: 'https://unsplash.com/photos/CT7IWRM7G5k',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Play with a friend online at Battleship',
      media: [
        {
          type: mediaTypes.link,
          link: 'http://en.battleship-game.org/',
          text: '▶️ Battle Ship game link',
          image: `${imagePathPrefix}/socializing/2.jpg`,
          origin: 'https://unsplash.com/photos/-subrrYxv8A',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Call your grandparents',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/3.jpg`,
          origin: 'https://unsplash.com/photos/PpZasS086os',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Call your parents',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/4.jpg`,
          origin: 'https://unsplash.com/photos/Cc10IJDoj78',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Order food for your parents/grandparents at home',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/5.jpg`,
          origin: 'https://unsplash.com/photos/afDu-GuxjjM',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Order groceries for your parents/grandparents at home',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/6.jpg`,
          origin: 'https://unsplash.com/photos/NLU117HCVuc',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Surprise your friend/sister/mom, order flowers delivery',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/7.jpg`,
          origin: 'https://unsplash.com/photos/iLCMK21AWqE',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Get a little pet (guinea pig, parrot, rabbit)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/8.jpg`,
          origin: 'https://unsplash.com/photos/3fjyk4CLfvA',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Romantic dinner with candles',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/9.jpg`,
          origin: 'https://unsplash.com/photos/GkK35qY2QsY',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Create an account in the social network where you are not yet',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/10.jpg`,
          origin: 'https://unsplash.com/photos/yyMJNPgQ-X8',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Call a familiar person you haven\'t talked to in over a year',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/11.jpg`,
          origin: 'https://unsplash.com/photos/L3qUP8MpExc',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Play a board game',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/12.jpg`,
          origin: 'https://unsplash.com/photos/y7Qq9IrgpOA',
        },
      ],
    },
    {
      category: categories.socializing,
      title: 'Play hide and seek (if you\'re not living alone)',
      media: [
        {
          type: mediaTypes.image,
          link: `${imagePathPrefix}/socializing/13.jpg`,
          origin: 'https://unsplash.com/photos/sySclyGGJv4',
        },
      ],
    },
  ],
};




